import { OfficeBannerContent } from "./OfficeBannerContent";
import { OfficeBannerIcon } from "./OfficeBannerIcon";
import { OfficeBannerRoot } from "./OfficeBannerRoot";

export const OfficeBanner = {
  Root: OfficeBannerRoot,
  Content: OfficeBannerContent,
  Icon: OfficeBannerIcon,
};
